var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageSliderMarkerFullDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.982 5.488c6.618 6.618 6.8 17.291.412 24.132L17.703 43.208 5.01 29.62c-6.388-6.84-6.206-17.514.412-24.132 6.782-6.782 17.777-6.782 24.559 0z",
    fill: "#1B264F"
  })));
}
export default __webpack_public_path__ + "media/aboutPage/image-slider-marker-full-dark-03c73e33.svg";
export { SvgImageSliderMarkerFullDark as ReactComponent };